<template>
    <div class="component-config">
        <el-form
                v-if="this.data && Object.keys(this.data).length > 0"
                label-width="88px"
                label-position="left"
                size="mini">
            <el-form-item label="ID">
                <el-input readonly="readonly" v-model="data.prop" ></el-input>
            </el-form-item>
            <el-form-item label="数据表" v-if="!data.subfield && !['divider','viewtable'].includes(data.type)">
                <el-select v-model="data.table" placeholder="请选择"  @change="handleTableChange" >
                    <el-option
                    v-for="item in dbTables"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="字段名" v-if="!['gridtable','divider','viewtable'].includes(data.type)">
                <el-select v-model="data.field" filterable placeholder="请选择">
                    <el-option
                    v-for="item in getFields(data.table)"
                    :key="item.name"
                    :label=" item.coment? `${item.name}(${item.coment})` : item.name"
                    :value="item.name">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标题名" v-if="!['divider'].includes(data.type)">
                <el-input v-model="data.label"
                            placeholder="请输入标题名"></el-input>
            </el-form-item>
            <el-form-item :label="data.subfield?'单元格宽度':'标题宽度'" v-if="!['gridtable','divider','viewtable'].includes(data.type)"
                            >
                <el-input-number v-model="data.labelWidth"
                                controls-position="right"
                                placeholder="请输入标题宽度"
                                :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="占位提示"
                            v-if="!['gridtable','divider','texteditor','radio','timerange','upload','uploadimg','guid','rate','company','department','modifytime','modifyuser','createtime','createuser','viewtable'].includes(data.type)">
                <el-input v-model="data.placeholder"
                            placeholder="请输入占位提示"></el-input>
            </el-form-item>
            <el-form-item label="开始占位"
                v-if="['timerange'].includes(data.type)">
                <el-input v-model="data.startPlaceholder" placeholder="请输入开始占位"></el-input>
            </el-form-item>
            <el-form-item label="结束占位" 
                v-if="['timerange'].includes(data.type)">
                <el-input v-model="data.endPlaceholder" placeholder="请输入结束占位"></el-input>
            </el-form-item>
            <el-form-item label="表单栅格" 
                v-if="!data.subfield && !['gridtable','texteditor','viewtable'].includes(data.type)">
                <el-slider
                    v-model="data.span"
                    :step="6"
                    :min="6"
                    :max="24"
                    show-stops>
                    </el-slider>
            </el-form-item>

            <component :is="getComponent"
                            :data="data"></component>

            <div class="mt-8" v-if="['radio','checkbox','select','selectMultiple','treeselect','layerselect','areaselect','companySelect','departmentSelect','userSelect','switch'].includes(data.type) && !data.subfield" >
                <el-button @click="handleBtnClick()"  type="primary" size="mini" >添加值改变执行脚本</el-button>
            </div>
        </el-form>
        <div v-else style="width: 100%;
        text-align: center;
        margin-top: 100%;color:#909399;" >
            请选中组件进行设置！
        </div>


        <l-dialog 
            :title="$t('添加脚本')"
            :visible.sync="formVisible"
            :height="528"
            :width="720"
            @ok="handleCodeSave"
            @opened="handleOpenedForm"

            
            >
            <l-code-mirror v-model="code" mode="application/javascript" ></l-code-mirror>  
        </l-dialog>
    </div>
</template>

<script>


const requireComponent = require.context('./', true, /\.vue$/)
const myComponents = {}
requireComponent.keys().map(fileName => {
    const name = fileName.split('/')[1].split('.')[0]
    if(name != 'cascader'){
        myComponents[`config-${name}`] = requireComponent(fileName).default
    }
    
})

export default {
    name: 'component-config',
    inject: ["formDesign"],
    props: ['data'],
    components:{
        ...myComponents
    },
    computed: {
        getComponent () {
            const prefix = 'config-'
            const { type } = this.data
            return prefix + type
        },
        dbTables(){
            return this.formDesign.dbTables;
        }
    },
    data () {
        return {
            formVisible:false,
            code:''
        }
    },
    methods: {
        handleTableChange(val){
            if(this.data.children){
                this.data.children.forEach(item => {
                    item.table = val;
                });
            }
        },
        getFields(tableName){
            let table = this.formDesign.dbTables.find(t=>t.name == tableName) || {};
            return table.columns || [];
        },

        handleBtnClick(){
            this.formVisible = true
        },

        handleCodeSave(){
            const {res,msg} = this.$getFunction(this.code)
            if(res){
                this.data.changeCode = this.code
                this.formVisible = false
            }
            else{
                this.$message({
                    type: 'error',
                    message: `脚本错误:${msg}`
                })
            }
        },
        handleOpenedForm(){
            this.code = this.data.changeCode || `({data,formData,setFormData,setRequired,setDisabled})=>{
  /*在此编写代码,data当前组件的值,formData表单数据,
  setFormData 设置表单某个组件数据,参数(v,prop),
  setRequired 设置必填项,
  setDisabled 设置只读项*/
  
}`
        }
    }
}
</script>
